import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["src", "alt", "sizeKey", "priority"];
import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@blaze-cms/image-cdn-react';
import Head from 'next/head';
import { useInView } from '@blaze-react/utils/lib/customHooks';
import { IN_VIEW_CONFIG } from '../../constants';
const LazyImage = _ref => {
  let {
      src,
      alt,
      sizeKey,
      priority
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const [isIntersecting, outerRef] = useInView(IN_VIEW_CONFIG);
  const shouldRender = priority || isIntersecting;
  const HeadComponent = priority ? Head : null;
  return /*#__PURE__*/React.createElement("span", {
    ref: outerRef
  }, shouldRender && /*#__PURE__*/React.createElement(ResponsiveImage, _extends({
    src: src,
    alt: alt,
    sizeKey: sizeKey,
    HeadComponent: HeadComponent
  }, props)));
};
LazyImage.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  sizeKey: PropTypes.string.isRequired,
  priority: PropTypes.bool
};
LazyImage.defaultProps = {
  alt: '',
  priority: false
};
export default LazyImage;
//# sourceMappingURL=LazyImage.js.map